import { avatarSrc } from "../lib/api";
import { VerifiedBadge } from "./VerifiedBadge";

export const UserSuggestions = ({ users, active, onPick, testid = "mention-suggestions", up = false }) => {
  if (!users.length) return null;
  return (
    <div data-testid={testid} className={`absolute left-0 z-[70] w-72 max-w-[calc(100vw-2rem)] bg-[#141518] border border-white/10 rounded-xl shadow-[0_12px_40px_rgba(0,0,0,0.6)] overflow-hidden ${up ? "bottom-full mb-2" : "top-full mt-2"}`}>
      {users.map((u, i) => (
        <button
          type="button"
          key={u.id}
          data-testid={`${testid}-item-${u.username}`}
          onMouseDown={(e) => { e.preventDefault(); onPick(u); }}
          className={`w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors ${i === active ? "bg-[#0066FF]/15" : "hover:bg-white/[0.05]"}`}
        >
          {u.avatar_url
            ? <img src={avatarSrc(u.avatar_url)} alt="" className="w-8 h-8 rounded-full object-cover bg-[#0B0C10] shrink-0" />
            : <span className="w-8 h-8 rounded-full bg-[#0066FF] text-white text-sm font-semibold flex items-center justify-center shrink-0">{(u.display_name || u.username)[0]?.toUpperCase()}</span>}
          <span className="min-w-0 leading-tight">
            <span className="flex items-center gap-1 text-white text-sm font-semibold truncate">{u.display_name || u.username}<VerifiedBadge show={u.verified} size={12} testId={`suggest-verified-${u.username}`} /></span>
            <span className="block text-[#8A8D91] text-xs truncate">@{u.username}</span>
          </span>
        </button>
      ))}
    </div>
  );
};
